module.exports = __webpack_public_path__ + "img/20190726161056048.4e2ef34b.png";